// components/LanguageSelector.js
import React from 'react';
import { useTranslation } from '../lib/translationContext.jsx';

const LanguageSelector = ({ className = '' }) => {
  const { 
    currentLanguage, 
    availableLanguages, 
    setLanguage, 
    getLanguageLabel 
  } = useTranslation();

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    setLanguage(selectedLanguage);
  };

  const isHeaderSelector = className.includes('header-language-selector');

  return (
    <div className={`language-selector ${className}`}>
      <select 
        value={currentLanguage}
        onChange={handleLanguageChange}
        className="language-select"
        style={isHeaderSelector ? {
          padding: '5px 8px',
          fontSize: '14px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          backgroundColor: 'white',
          color: '#333',
          fontFamily: 'principal-font'
        } : {}}
      >
        {availableLanguages.map(lang => (
          <option key={lang} value={lang}>
            {getLanguageLabel(lang)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;